import { createSlice } from "@reduxjs/toolkit";
import { FilterStateTermValidation } from "./types";

const INITIAL_STATE: FilterStateTermValidation = {
  filters: {
    search: "",
    store: "",
    status: "",
    reason: "",
    sla_status: "",
    start_date: "",
    end_date: "",
    orderBy: { created_at: "desc" },
    meta: {
      page: 1,
      perPage: 10,
    },
  },
};

const termValidationFilterSlice = createSlice({
  name: "termValidationFilter",
  initialState: INITIAL_STATE,
  reducers: {
    setTermValidationFilter(state, action) {
      const { key, value } = action.payload;

      if (key === "meta") {
        state.filters.meta = {
          ...state.filters.meta,
          ...value,
        };
      } else {
        state.filters[key] = value;
      }
    },
    clearTermValidationFilters(state) {
      state.filters = { ...INITIAL_STATE.filters };
    },
  },
});

export const { setTermValidationFilter, clearTermValidationFilters } =
  termValidationFilterSlice.actions;

export default termValidationFilterSlice.reducer;